export default {
  route: {
    '爱乐教': '爱乐教',
    '首页': '首页',
    '登录': '登录',
    '幼儿园管理': '幼儿园管理',
    '集团管理': '集团管理',
    '班级管理': '班级管理',
    '地点管理': '地点管理',
    '统计管理': '统计管理',
    '用户管理': '用户管理',
    '专家与教师绑定': '专家与教师绑定',
    '学生与家长绑定': '学生与家长绑定',
    '园长与幼儿园绑定': '园长与幼儿园绑定',
    '专业老师与幼儿园绑定': '专业老师与幼儿园绑定',
    '保健医与学生绑定': '保健医与学生绑定',
    '校车老师与校车绑定': '校车老师与校车绑定',
    '学生管理': '学生管理',
    '学生档案': '学生档案',
    '学生考勤': '学生考勤',
    '学生校车考勤': '学生校车考勤',
    '假条补交': '假条补交',
    '学生评量': '学生评量',
    '教学管理': '教学管理',
    '轶事记录': '轶事记录',
    '课程记录': '课程记录',
    '教案': '教案',
    '教学记录': '教学记录',
    '学生作品': '学生作品',
    '专家点评率': '专家点评率',
    '预设教案': '预设教案',
    '培训资料管理': '培训资料管理',
    '家庭作业': '校外活动',
    '轶事记录评价': '轶事记录评价',
    '课程记录评价': '课程记录评价',
    '叮嘱反馈': '叮嘱反馈',
    '关怀问候反馈': '关怀问候反馈',
    '状态信息查询': '状态信息查询',
    '日常应用': '日常应用',
    '服药单': '服药单',
    '校园通知': '校园通知',
    '请销假': '请销假',
    '叮嘱': '叮嘱',
    '关怀问候': '关怀问候',
    '健康日报': '健康日报',
    '表格模板': '表格模板',
    '表格管理': '表格管理',
    '托婴': '托婴',
    '宝贝情绪': '宝贝情绪',
    '三餐辅食': '三餐辅食',
    '日饮水量': '日饮水量',
    '健康记录': '健康记录',
    '校车管理': '校车管理',
    '资料下载': '资料下载',
    '外部设备管理': '外部设备管理',
    '磊盛人脸识别设备管理': '磊盛人脸识别设备管理',
    '厂拍人脸识别设备管理': '厂拍人脸识别设备管理',
    '学生IC卡管理': '学生IC卡管理',
    '招生小程序': '招生小程序',
    '财务': '财务',
    '学费单模板': '学费单模板',
    '学费单': '学费单',
    '退费计算方法': '退费计算方法',
    '学费档案': '学费档案',
    '工资单': '工资单',
    '评量管理': '评量管理',
    '类别与指标': '类别与指标',
    '评量清单管理': '评量清单管理',
    '班级圈': '班级圈',
    '教师打卡设置': '教师打卡设置',
    '教师打卡记录': '教师打卡记录',
    '学园手册': '学园手册'
  },
  role: {
    '园长': '园长',
    '专家': '专家',
    '教师': '教师',
    '家长': '家长',
    '幼儿园管理员': '幼儿园管理员',
    '超级管理员': '超级管理员',
    '保健医': '保健医',
    '校车老师': '校车老师',
    '集团领导': '集团领导',
    '教育局领导': '教育局领导',
    '专业老师': '专业老师',
    '招生老师': '招生老师',
    '财务': '财务',
    '集团管理员': '集团管理员',
    '集团招生老师': '集团招生老师',
    '用户id': '用户id'
  },
  login: {
    title: '登录',
    '退出': '退出'
  },
  placeholder: {
    '提示': '提示',
    '状态': '状态',
    '请先保存后再预览，确认要预览吗？': '请先保存后再预览，确认要预览吗？',
    '请确认是否保存，确定要关闭吗？': '请确认是否保存，确定要关闭吗？',
    '确认要提交吗？': '确认要提交吗？',
    '确定要删除吗？': '确定要删除吗？',
    '确定要删除所选项吗？': '确定要删除所选项吗？',
    '确定要下载所选项吗？': '确定要下载所选项吗？',
    '确定要下载所选学生的数据吗？': '确定要下载所选学生的数据吗？',
    '确定要发送吗？': '确定要发送吗？',
    '确定要删除图片吗？': '确定要删除图片吗？',
    '请选择所要删除的对象': '请选择所要删除的对象',
    '请选择所要下载的对象': '请选择所要下载的对象',
    '追加成功': '追加成功',
    '保存成功': '保存成功',
    '删除成功': '删除成功',
    '编辑成功': '编辑成功',
    '添加成功': '添加成功',
    '审核成功': '审核成功',
    '更新成功': '更新成功',
    '提交成功': '提交成功',
    '草稿保存成功': '草稿保存成功',
    '请先保存': '请先保存',
    '请选择': '请选择',
    '请输入': '请输入',
    '请选择学生': '请选择学生',
    '请选择日期': '请选择日期',
    '请选择班级': '请选择班级',
    '请选择时间': '请选择时间',
    '请选择集团': '请选择集团',
    '请选择幼儿园': '请选择幼儿园',
    '请选择状态': '请选择状态',
    '请选择名称': '请选择名称',
    '请选择园长': '请选择园长',
    '请选择专业老师': '请选择专业老师',
    '请选择学生搜索': '请选择学生搜索',
    '请选择班级搜索': '请选择班级搜索',
    '请选择幼儿园搜索': '请选择幼儿园搜索',
    '请选择集团搜索': '请选择集团搜索',
    '请选择标题搜索': '请选择标题搜索',
    '请选择校车老师搜索': '请选择校车老师搜索',
    '请选择校车搜索': '请选择校车搜索',
    '请选择教师名称搜索': '请选择教师名称搜索',
    '请选择版本': '请选择版本',
    '请添加内容': '请添加内容',
    '请输入园长搜索': '请输入姓名搜索',
    '请输入标题': '请输入标题',
    '请输入学生姓名搜索': '请输入学生姓名搜索',
    '请输入标题搜索': '请输入标题搜索',
    '请输入内容搜索': '请输入内容搜索',
    '请输入学生姓名': '请输入学生姓名',
    '请输入内容': '请输入内容',
    '请输入地点名称': '请输入地点名称',
    '无图片显示': '无图片显示',
    '选择日期': '选择日期',
    '选择月份': '选择月份',
    '请选择开始日期': '请选择开始日期',
    '请选择结束日期': '请选择结束日期',
    '提示：排序值越大，文件位置越靠前': '提示：排序值越大，文件位置越靠前',
    '暂不支持上传视频': '暂不支持上传视频',
    '请输入托班总分': '请输入托班总分',
    '请输入小班总分': '请输入小班总分',
    '请输入中班总分': '请输入中班总分',
    '请输入大班总分': '请输入大班总分',
    '密码提示': '请输入密码',
    '密码强度提示': '密码最小长度为8，且必须包含大小写英文，数字和符号这4种字符中的3种（连续数字等特殊字符组合也不允许）。如果不符合上述条件，用户首次登录时需修改密码',
    '密码强度提示2': '密码最小长度为8，且必须包含大小写英文，数字和符号这4种字符中的3种（连续数字等特殊字符组合也不允许）',
    '密码': '密码',
    '手机提示': '请输入手机号',
    '手机': '手机号',
    '只能上传mp4文件': '只能上传mp4文件',
    '学生国籍不能为空': '学生国籍不能为空',
    '学生照片不能为空': '学生照片不能为空',
    '父亲姓名不能为空': '父亲姓名不能为空',
    '母亲姓名不能为空': '母亲姓名不能为空',
    '父亲单位与职位不能为空': '父亲单位与职位不能为空',
    '母亲单位与职位不能为空': '母亲单位与职位不能为空',
    '父亲电子邮件不能为空': '父亲电子邮件不能为空',
    '母亲电子邮件不能为空': '母亲电子邮件不能为空',
    title: '请输入名称',
    // ------------------------
    '家长或学生姓名': '家长或学生姓名',
    '请先上传文件': '请先上传文件',
    '请先选择文件': '请先选择文件',
    '是否保存上传文件?': '是否保存上传文件？',
    '输入用户名称搜索': '输入用户名称搜索',
    '选择集团搜索': '请选择集团搜索',
    '选择幼儿园搜索': '请选择幼儿园搜索',
    '选择班级搜索': '请选择班级搜索',
    '选择学生搜索': '请选择学生搜索',
    '选择角色搜索': '请选择角色搜索',
    '真实姓名': '姓名',
    '初始密码': '新密码',
    '确认密码': '确认密码',
    '性别': '性别',
    '是否启用': '是否启用',
    '邮箱': '邮箱',
    '集团': '集团',
    '幼儿园': '幼儿园',
    '班级': '班级',
    '角色': '角色',
    '默认角色': '默认角色',
    '初始积分': '初始积分',
    '学生': '学生',
    '正常金额': '正常金额',
    '折扣': '折扣',
    '折后金额': '折后金额',
    '入学日期': '入学日期',
    '退款天数设置必须填写完整': '退款天数设置必须填写完整',
    '项目名称和数值不能为空': '项目名称和数值不能为空',
    '请添加缴费项目': '请添加缴费项目',
    '请填写每个月的天数': '请填写每个月的天数',
    'IC卡号不能为空': 'IC卡号不能为空',
    '请选择项目名称': '请选择项目名称',
    '订单编号': '订单编号',
    '订单名称': '订单名称',
    '付款金额': '付款金额',
    '付款时间': '付款时间',
    '是否通知所有未通知的家长缴费?': '是否通知所有未通知的家长缴费？',
    '通知成功': '通知成功',
    '是否通知家长缴费?': '是否通知家长缴费？',
    '是否确认此学费单？': '是否确认此学费单？',
    '确认缴费单成功!': '确认缴费单成功！',
    '确定要删除吗?': '确定要删除吗？',
    '0-100，例：7折对应的值是30': '0-100，例：7折对应的值是30',
    '学生不能为空': '学生不能为空',
    '学生姓名不能为空': '学生姓名不能为空',
    '学生姓名搜索': '学生姓名搜索',
    '标题不能为空': '标题不能为空',
    '标题': '标题',
    '新建': '新建',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '请上传视频文件': '请上传视频文件',
    '除备注外均为必填项': '除备注外均为必填项',
    '推送成功': '推送成功'
  },
  button: {
    '确定': '确定',
    '取消': '取消',
    '关闭': '关闭',
    '预览': '预览',
    '提交': '提交',
    '返回': '返回',
    '保存': '保存',
    '导入': '导入',
    '上传图片': '上传图片',
    '上传视频': '上传视频',
    '点击上传': '点击上传',
    '保存草稿': '保存草稿',
    '删除图片': '删除图片',
    '删除': '删除',
    '加图片': '加图片',
    '加文字': '加文字',
    '全选': '全选',
    '新建': '新建',
    '添加': '添加',
    '评价': '评价',
    '查看详细': '查看详情',
    '详情': '详情',
    '反馈': '反馈',
    '下载': '下载',
    '下载教委版': '下载教委版',
    '搜索': '搜索',
    '关联': '关联',
    '完成': '完成',
    '保存并继续': '保存并继续',
    '新建文件夹': '新建文件夹',
    '查看': '查看',
    '查看详情': '查看详情',
    // ------------------------
    '编辑': '编辑',
    '全员档案下载': '全员档案下载',
    '一键通知缴费': '一键通知缴费',
    '批量导入': '批量导入',
    '批量下载': '批量下载',
    '批量下载教委版': '批量下载教委版',
    '选取文件': '选取文件',
    '上传': '上传',
    '设置': '设置',
    '查看封面图片': '查看封面图片',
    '查看视频': '查看视频',
    '新建系列': '新建系列',
    '新建视频': '新建视频',
    '预缴学费下载': '预缴学费下载',
    '通知全体教师': '通知全体教师',
    '通知全体教师和家长': '通知全体教师和家长',
    '执行': '执行',
    '查询': '查询',
    '请求金额': '请求金额',
    '已支付金额': '已支付金额',
    '元': '元'
  },
  date: {
    '今天': '今天',
    '昨天': '昨天',
    '一周前': '一周前',
    '年': '年',
    '月': '月',
    '日': '日',
    '选择月': '选择月',
    '至': ' 至 ',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '选择时间': '选择时间',
    'YYYY年MM月': 'YYYY年MM月',
    '请选择日期范围': '请选择日期范围'
  },
  list: {
    '全部': '全部',
    '未评价': '未评价',
    '已评价': '已评价',
    '草稿': '草稿',
    '已发布': '已发布',
    '待评价': '待评价',
    '预备': '预备',
    '在校': '在校',
    '已毕业': '已毕业',
    '未反馈': '未反馈',
    '已反馈': '已反馈',
    '普通': '普通',
    '校车': '校车',
    '保健医': '保健医',
    '待完成': '待完成',
    '已完成': '已完成',
    '取消': '取消',
    '待确认': '待确认',
    '已确认': '已确认',
    '确认': '确认',
    '轶事记录': '轶事记录',
    '教案': '教案',
    '已提交': '已提交',
    '请假': '请假',
    '销假': '销假',
    '事假': '事假',
    '病假': '病假',
    '校车假': '校车假',
    '未启用': '未启用',
    '启用': '启用',
    '缴费': '缴费',
    // ----------------------------
    '未通知缴费': '未通知缴费',
    '已通知待缴费': '已通知待缴费',
    '待缴费': '待缴费',
    '已缴费': '已缴费',
    '未通知': '未通知',
    '已缴费待确认': '已缴费待确认',
    '缴费项目': '缴费项目',
    '其它': '其它',
    'IC卡号': 'IC卡号',
    '家长或学生姓名': '家长或学生姓名',
    '总金额：': '总金额：',
    '自动算出的退费项目（非金额）': '自动算出的退费项目（非金额）',
    '自动算出的退费项目（金额）': '自动算出的退费项目（金额）',
    '未入账': '未入账',
    '已入账': '已入账',
    '审核未通过': '审核未通过',
    '待审核': '待审核',
    '审核通过': '审核通过'
  },
  table: {
    '标题': '标题',
    '序号': '序号',
    '幼儿园': '幼儿园',
    '班级': '班级',
    '创建人': '创建人',
    '创建时间': '创建时间',
    '状态': '状态',
    '类型': '类型',
    '操作': '操作',
    '名称': '名称',
    '英文名称': '英文名称',
    '排序': '排序',
    '托班': '托班',
    '小班': '小班',
    '中班': '中班',
    '大班': '大班',
    '选项': '选项',
    '删除': '删除',
    '发布时间': '发布时间',
    '发布人': '发布人',
    '校车老师': '校车老师',
    '校车': '校车',
    '提交家长': '提交家长',
    '查看付款人': '查看付款人',
    // ------------------
    '': '',
    '学生所在班级': '学生所在班级',
    '所属幼儿园': '所属幼儿园',
    '家长姓名': '家长姓名',
    '家长手机号': '家长手机号',
    '创建日期': '创建日期',
    '图片': '图片',
    '内容': '内容',
    '日期': '日期',
    '用户名称': '用户名称',
    '手机': '手机号',
    '角色': '角色',
    '集团': '集团',
    '是否已启用': '是否已启用',
    '姓名': '姓名',
    '标准金额': '标准金额',
    '折扣': '折扣',
    '折后金额': '折后金额',
    '学费起止日': '学费起止日',
    '缴费截止日': '缴费截止日',
    '退费起止日': '退费起止日',
    '缴费项目': '缴费项目',
    '备注': '备注',
    '班级名称': '班级名称',
    '学生姓名': '学生姓名',
    '金额': '金额',
    '付款人': '付款人',
    '学生': '学生',
    '模板': '模板',
    '添加选项': '添加选项',
    '自动退费核算': '自动退费核算',
    '作者': '作者',
    '作者头衔': '作者头衔',
    '介绍': '介绍',
    '封面图片': '封面图片',
    '视频时长': '视频时长',
    '教案文件(pdf)': '教案文件(pdf)',
    '备课视频(mp4)': '备课视频(mp4)',
    '开始月份': '开始月份',
    '结束月份': '结束月份',
    '总金额': '总金额',
    '已消费金额': '已消费金额',
    '预缴费起止月': '预缴费起止月'
  },
  form: {
    '学生': '学生',
    '年龄': '年龄',
    '内容': '内容',
    '集团': '集团',
    '幼儿园': '幼儿园',
    '班级': '班级',
    '日期': '日期',
    '校车老师': '校车老师',
    '地点': '地点',
    '视频': '视频'
  },
  title: {
    '新建关联': '新建关联',
    '关联管理': '关联管理',
    '新建': '新建',
    '编辑': '编辑',
    // -----------------------------
    '日饮水量': '日饮水量',
    '时间': '时间',
    '水量': '水量',
    '幼儿园出勤基准天数': '幼儿园出勤基准天数',
    '学费自动生成设置': '学费自动生成设置',
    '请确认缴费单': '请确认缴费单',
    '付款详情': '付款详情',
    '批量上传': '批量上传',
    '添加学生与家长绑定': '添加学生与家长绑定'
  },
  message: { // ----------------------------
    '更新成功': '更新成功'
  },
  error: { // ----------------------------
    '请输入密码': '请输入密码',
    '两次密码必须一致': '两次密码必须一致',
    '请输入手机号': '请输入手机号',
    '请选择集团': '请选择集团',
    '请选择幼儿园': '请选择幼儿园',
    '请选择班级': '请选择班级',
    '请选择角色': '请选择角色',
    '请选择默认角色': '请选择默认角色'
  },
  tuitionbills: { // ----------------------------
    '支付宝': '支付宝',
    '微信': '微信',
    '二维码加载中，请稍候...': '二维码加载中，请稍候...',
    '二维码加载失败，请关闭重试!': '二维码加载失败，请关闭重试！',
    '请打开支付宝App扫码支付': '请打开支付宝App扫码支付',
    '请打开微信扫码支付': '请打开微信扫码支付',
    '请求金额': '请求金额',
    '已支付金额': '已支付金额',
    '元': '元',
    '查询金额合计': '查询合计金额'
  },
  tuitionbillsdetail: { // ----------------------------
    '出勤情况：签到': '出勤情况：签到 ',
    '天': '',
    '请假': '请假: ',
    '项目名称：': '项目名称：',
    '数值：': '数值：',
    '日期': '日期',
    '天数': '天数',
    '计费方法': '计费方法'
  },
  tuitiondepositdetail: { // ----------------------------
    '已签到天数': '已签到天数',
    '折扣内天数': '折扣内天数',
    '折扣（% OFF）': '折扣（% OFF）'
  },
  activity: {
    '教学策划': '教学策划',
    '活动准备': '活动准备',
    '活动描述': '活动描述',
    '活动地点': '活动地点',
    '活动日期': '活动日期',
    '评量指标类别': '评量指标类别',
    '学生': '学生',
    '标题': '标题',
    '上一天': '上一天',
    '下一天': '下一天',
    '教学记录选择': '教学记录选择',
    '观察分析': '观察分析',
    '省思': '省思',
    '开放给家长': '开放给家长',
    '家长可见': '家长可见',
    '标题内容编辑': '标题内容编辑'
  },
  assessmentChecklists: {
    '评量清单指标关联编辑': '评量清单指标关联编辑'
  },
  assessmentObjectives: {
    '选项名称：': '选项名称：',
    '英文名称：': '英文名称：',
    '分数：': '分数：',
    '排序：': '排序：'
  },
  busTeacher: {
    '添加校车老师与校车绑定': '添加校车老师与校车绑定',
    '校车老师': '校车老师',
    '校车': '校车',
    '请选择关联校车': '请选择关联校车',
    '请选择校车老师': '请选择校车老师',
    '请选择校车': '请选择校车'
  },
  calendar: {
    '班级考勤表下载': '班级考勤表下载',
    '全园考勤表下载': '全园考勤表下载',
    '签到数据下载': '签到数据下载',
    '签到体温': '签到体温',
    '签退体温': '签退体温',
    '签到': '签到',
    '签退': '签退',
    '度': '度',
    '请选择签到时间': '请选择签到时间',
    '请选择签退时间': '请选择签退时间'
  },
  calendarBus: {
    '早班': '早班',
    '早班不坐': '早班不坐',
    '晚班': '晚班',
    '晚班不坐': '晚班不坐',
    '全天': '全天',
    '全天不坐': '全天不坐'
  },
  class: {
    '请输入班级名称': '请输入班级名称',
    '年毕业)': '年毕业)',
    '(': '('
  },
  classCircle: {
    '班级圈': '班级圈',
    '班级圈上传': '班级圈发布',
    '上传图片的格式只能是JPG/PNG格式!': '上传图片的格式只能是JPG/PNG格式!',
    '发布': '发布'
  },
  doctorStudent: {
    '添加保健医与学生绑定': '添加保健医与学生绑定',
    '请选择关联学生': '请选择关联学生',
    '请选择保健医': '请选择保健医',
    '请选择保健医搜索': '请选择保健医搜索',
    '请选择名称': '请选择名称',
    '名称': '名称'
  },
  entrust: {
    '叮嘱状态': '叮嘱状态',
    '叮嘱类型': '叮嘱类型',
    '学生：': '学生：',
    '发布人：': '发布人：',
    '发布时间：': '发布时间：',
    '确定要提交反馈吗？': '确定要提交反馈吗？'
  },
  expertTeacher: {
    '添加专家与教师绑定': '添加专家与教师绑定',
    '请选择关联教师': '请选择关联教师',
    '请选择专家名称搜索': '请选择专家名称搜索',
    '请选择专家': '请选择专家',
    '请选择教师': '请选择教师',
    '专家检索': '专家检索',
    '教师检索': '教师检索',
    '专家集团': '专家集团',
    '专家幼儿园': '专家幼儿园',
    '专家名称': '专家名称',
    '老师名称': '老师名称',
    '老师幼儿园': '老师幼儿园',
    '老师班级': '老师班级'
  },
  forms: {
    '园内模板': '园内模板',
    '公共模板': '公共模板',
    '查看模板': '查看模板',
    '编辑模板': '编辑模板',
    '新建模板': '新建模板'
  },
  tinymce: {
    '请等待上传成功。如果出现网络问题，请刷新页面并重新上传！': '请等待上传成功。如果出现网络问题，请刷新页面并重新上传！'
  },
  group: {
    '集团名称': '集团名称',
    '请输入集团名称': '请输入集团名称',
    '输入集团名称搜索': '输入集团名称搜索'
  },
  healthy: {
    '体温': '体温',
    '晨检体温': '晨检体温',
    '午检体温': '午检体温',
    '尿': '尿',
    '性状': '性状',
    '时间': '时间',
    '第1次': '第1次',
    '第2次': '第2次',
    '第3次': '第3次',
    '第4次': '第4次',
    '第5次': '第5次',
    '第6次': '第6次',
    '第7次': '第7次',
    '第8次': '第8次',
    '便': '便',
    '睡眠': '睡眠',
    '睡眠情况': '睡眠情况',
    '正常': '正常',
    '偏黄': '偏黄',
    '异常': '异常',
    '绿黑色': '绿黑色',
    '黄色(松软)': '黄色(松软)',
    '黄褐色': '黄褐色',
    '绿褐色': '绿褐色',
    '水样,褐色': '水样,褐色',
    '干,褐色,硬': '干,褐色,硬',
    '粉红色,半消化的食物': '粉红色,半消化的食物',
    '深绿色、厚而黑': '深绿色、厚而黑',
    '亮绿色、绿色多泡的': '亮绿色、绿色多泡的',
    '带有红色血丝,带有血或粘液的干便': '带有红色血丝,带有血或粘液的干便',
    '黑色、厚或柏油样': '黑色、厚或柏油样',
    '粉状、灰白色、无色或白色': '粉状、灰白色、无色或白色',
    'Normal': '正常',
    'Partial Yellow': '偏黄',
    'Unusual': '异常',
    'Dark Green': '绿黑色',
    'Yellow (soft)': '黄色(松软)',
    'Yellowish-brown': '黄褐色',
    'Greenish brown': '绿褐色',
    'Liquid Daeces, Brown': '水样,褐色',
    'Dry, brown, hard': '干,褐色,硬',
    'Pink, Semi-digested Food': '粉红色,半消化的食物',
    'Dark Green, Thick & Black': '深绿色、厚而黑',
    'Light Green, Green & Bubbly': '亮绿色、绿色多泡的',
    'Bloodshot, Bloody & Mucinous Stool': '带有红色血丝,带有血或粘液的干便',
    'Black, Thick, Tarry Stool': '黑色、厚或柏油样',
    'Stool, Grayish White, Colourless or White': '粉状、灰白色、无色或白色'
  },
  meal: {
    '奶量': '奶量',
    '早餐': '早餐',
    '中餐': '中餐',
    '晚餐': '晚餐',
    '水果': '水果',
    '又添一份': '又添一份',
    '全部吃完': '全部吃完',
    '吃一半': '吃一半',
    '多半': '多半',
    '吃一半（仅荤）': '吃一半（仅荤）',
    '吃一半（仅素）': '吃一半（仅素）',
    '少量': '少量',
    '未食': '未食',
    'Additional Portion': '又添一份',
    'Finish All': '全部吃完',
    'Finish Half': '吃一半',
    'Finish More than Half': '多半',
    'Finish All (meat only)': '吃一半（仅荤）',
    'Finish All (vegetables only)': '吃一半（仅素）',
    'A Little': '少量',
    'Not Eaten': '未食'
  },
  kindergarten: {
    '省份': '省份',
    '请选择省份': '请选择省份',
    '城市': '城市',
    '区': '区',
    '详细地址': '详细地址',
    '经度': '经度',
    '纬度': '纬度',
    '合同起始日期': '合同起始日期',
    '合同终止日期': '合同终止日期',
    '合同剩余天数': '合同剩余天数',
    '最大班级数': '最大班级数',
    '请输入幼儿园名称搜索': '请输入幼儿园名称搜索',
    '请输入幼儿园名称': '请输入幼儿园名称',
    '版本': '版本',
    '标准版': '标准版',
    '轻量版': '轻量版',
    '托育版': '托育版'
  },
  leaveNotes: {
    '假条类型': '假条类型',
    '请假类型': '请假类型',
    '假条状态': '假条状态',
    '校车时间': '校车时间',
    '请假日期': '请假日期',
    '校车假详情': '校车假详情',
    '提交时间': '提交时间',
    '审核': '审核',
    '事由': '事由',
    '留言': '留言',
    '姓名：': '姓名：',
    '时间：': '时间：',
    '类型：': '类型：',
    '校车假详细：': '校车假详细：',
    '状态：': '状态：',
    '学生家长：': '学生家长：',
    '提交时间：': '提交时间：',
    '事由：': '事由：',
    '审核教师：': '审核教师：',
    '教师留言：': '教师留言：',
    '假条状态：': '假条状态：',
    '反馈：': '反馈：',
    '【请假条】': '【请假条】',
    '【销假条】': '【销假条】'
  },
  lesunFaceDevices: {
    '请选择状态搜索': '请选择状态搜索',
    '姓名': '姓名',
    '状态码': '状态码',
    '错误信息': '错误信息',
    '失败': '失败',
    '成功': '成功',
    '设备': '设备',
    '请输入设备序列号': '请输入设备序列号',
    '刷新列表': '刷新列表',
    '设备序列号': '设备序列号',
    '绑定幼儿园': '绑定幼儿园',
    '下发': '下发',
    '下发QR': '下发二维码',
    '下发结果': '下发结果',
    '离线': '离线',
    '上线': '上线',
    '确定要下发吗？': '确定要下发吗？',
    '已开始下发！请稍候查看下发结果！': '已开始下发！请稍候查看下发结果！'
  },
  mood: {
    '请选择情绪': '请选择情绪',
    '非常好': '非常好',
    '稳定': '稳定',
    '分离焦虑': '分离焦虑',
    'Very Good': '非常好',
    'Stable': '稳定',
    'Separation Anxiety': '分离焦虑'
  },
  notice: {
    '通知': '通知',
    '照片': '照片',
    '发布': '发布',
    '上传成功': '上传成功',
    '附件上传': '附件上传',
    '请先保存草稿': '请先保存草稿',
    '将文件拖到此处，或': '将文件拖到此处，或',
    '请选择通知对象': '请选择通知对象',
    '请输入通知内容': '请输入通知内容',
    '图片传输中……': '图片传输中……',
    '上传图片失败': '上传图片失败',
    '上传图片的格式只能是JPG/MP4/PNG格式!': '上传图片的格式只能是 JPG/MP4/PNG 格式!',
    '图片删除成功': '图片删除成功',
    '图片删除失败': '图片删除失败',
    '确定要发送通知吗？': '确定要发送通知吗？',
    '确定要通知未读人吗？': '确定要通知未读人吗？',
    '通知未读人': '通知未读人',
    '通知未读人成功': '通知未读人成功',
    '未读人': '未读人',
    '新建富文本通知': '新建富文本通知',
    '新建简易通知': '新建简易通知'
  },
  predesignTeachingPlan: {
    '查看教案文件': '查看教案文件',
    '查看教案视频': '查看教案视频',
    '文件格式错误': '文件格式错误',
    '必须在相同集团添加或修改': '必须在相同集团添加或修改',
    '请上传pdf文件': '请上传pdf文件',
    '班级绑定设置': '班级绑定设置',
    '班级绑定清空': '班级绑定清空',
    '是否清空已选班级设置？': '是否清空已选班级设置？',
    '班级关联清除成功': '班级关联清除成功',
    '请选择教案': '请选择教案'
  },
  principalKindergarten: {
    '添加园长与幼儿园绑定': '添加园长与幼儿园绑定',
    '请选择关联幼儿园': '请选择关联幼儿园'
  },
  refundCaculations: {
    '餐费': '餐费',
    '退费方法': '退费方法',
    '请选择退费方法': '请选择退费方法',
    '月标准价格': '月标准价格',
    '每日价格': '每日价格',
    '四舍五入方法': '四舍五入方法',
    '请选择四舍五入计算方法': '请选择四舍五入计算方法',
    '价格不能小于等于0': '价格不能小于等于0',
    '退费方法不能为空': '退费方法不能为空',
    '四舍五入方法不能为空': '四舍五入方法不能为空',
    '精算（按月参考天数计算单价）': '精算（按月参考天数计算单价）',
    '每日固定金额': '每日固定金额',
    '无四舍五入精确到分': '无四舍五入精确到分',
    '四舍五入精确到元': '四舍五入精确到元'
  },
  register: {
    '注册': '注册',
    '重置': '重置',
    '确认密码': '确认密码',
    '幼儿园注册码': '幼儿园注册码',
    '获取班级列表': '获取班级列表',
    '短信验证码': '验证码',
    '获取短信验证码': '获取验证码',
    '请再次输入密码': '请再次输入密码',
    '两次输入密码不一致！': '两次输入密码不一致！',
    '请输入幼儿园注册码': '请输入幼儿园注册码',
    '请输入姓名': '请输入姓名',
    '请输入短信验证码': '请输入短信验证码',
    '注册成功！': '注册成功！'
  },
  schoolBus: {
    '站点名称': '站点名称',
    '站点不停靠': '站点不停靠',
    '早上到达时间': '早上到达时间',
    '晚上到达时间': '晚上到达时间',
    '添加校车': '添加校车',
    '(早班)': '(早班)',
    '(晚班)': '(晚班)',
    '无': '无',
    '编辑校车': '编辑校车',
    '添加站点': '添加站点',
    '校车名称': '校车名称',
    '跟车教师一': '跟车教师一',
    '跟车教师二': '跟车教师二',
    '跟车教师一：': '跟车教师一：',
    '跟车教师二：': '跟车教师二：'
  },
  schoolBusDownload: {
    '叮嘱下载': '叮嘱下载',
    '请假下载': '请假下载'
  },
  statistics: {
    '基本统计': '基本统计',
    '用户:': '用户:',
    '活跃用户:': '活跃用户:',
    '幼儿园:': '幼儿园:',
    '园长:': '园长:',
    '专家:': '专家:',
    '教师:': '教师:',
    '校医:': '校医:',
    '校车老师:': '校车老师:',
    '轶事记录总数:': '轶事记录总数:',
    '教案总数:': '教案总数:',
    '图片总数:': '图片总数:',
    '家长:': '家长:',
    '学生:': '学生:',
    '已毕业学生:': '已毕业学生:',
    '时间范围统计': '时间范围统计',
    '新增轶事记录:': '新增轶事记录:',
    '新增教案:': '新增教案:',
    '新增图片:': '新增图片:',
    '故事阅读量统计': '故事阅读量统计',
    '幼儿园管理员:': '幼儿园管理员:',
    '阅读数': '阅读数'
  },
  student: {
    '学生通讯录下载': '学生通讯录下载',
    '学生名单导入': '学生名单导入',
    '二维码下载': '二维码下载',
    '二维码重置并下载': '二维码重置并下载',
    '填表人签字': '填表人签字',
    '学生信息': '学生信息',
    '幼儿1寸照片': '幼儿1寸照片',
    '父亲1寸照片': '父亲1寸照片',
    '母亲1寸照片': '母亲1寸照片',
    '学生姓名': '学生姓名',
    '性别': '性别',
    '学生状态': '学生状态',
    '父亲姓名': '父亲姓名',
    '电话': '电话',
    '母亲姓名': '母亲姓名',
    '昵称': '昵称',
    '生日': '生日',
    '身份证号码': '身份证号码',
    '身份证/护照': '身份证/护照',
    '国籍': '国籍',
    '出生地': '出生地',
    '家庭地址': '家庭地址',
    '家庭电话': '家庭电话',
    '邮编': '邮编',
    '身体健康信息': '身体健康信息',
    '病症名称': '病症名称',
    '是': '是',
    '否': '否',
    '发觉该病时的年龄': '发觉该病时的年龄',
    '贫血症': '贫血症',
    '糖尿病': '糖尿病',
    '阑尾炎': '阑尾炎',
    '腮腺炎': '腮腺炎',
    '哮喘': '哮喘',
    '小儿麻痹症': '小儿麻痹症',
    '骨裂': '骨裂',
    '外科手术': '外科手术',
    '水痘': '水痘',
    '风湿热': '风湿热',
    '麻疹（10日风疹）': '麻疹（10日风疹）',
    '风疹': '风疹',
    '白喉': '白喉',
    '猩红热': '猩红热',
    '耳部感染': '耳部感染',
    '痉挛或惊厥': '痉挛或惊厥',
    '湿疹': '湿疹',
    '扁桃腺炎': '扁桃腺炎',
    '癫痫症': '癫痫症',
    '扁桃腺切除': '扁桃腺切除',
    '腺体热': '腺体热',
    '肺结核': '肺结核',
    '干草热': '干草热',
    '百日咳': '百日咳',
    '心脏病或心脏杂音': '心脏病或心脏杂音',
    '其他': '其他',
    '你的孩子是否对某种药物过敏': '你的孩子是否对某种药物过敏',
    '过敏药物种类及症状': '过敏药物种类及症状',
    '紧急治疗建议': '紧急治疗建议',
    '你的孩子是否对某种食物过敏': '你的孩子是否对某种食物过敏',
    '过敏食物种类及症状': '过敏食物种类及症状',
    '你的孩子是否有其他过敏': '你的孩子是否有其他过敏',
    '过敏源及症状': '过敏源及症状',
    '您的孩子是否有视觉缺陷': '您的孩子是否有视觉缺陷',
    '您的孩子是否有听觉缺陷': '您的孩子是否有听觉缺陷',
    '您的孩子是否接受过语言能力治疗': '您的孩子是否接受过语言能力治疗',
    '你的孩子是否接受过行为控制治疗': '你的孩子是否接受过行为控制治疗',
    '您的孩子是否有学习能力障碍': '您的孩子是否有学习能力障碍',
    '您的孩子是否经常或周期性地接受药物治疗': '您的孩子是否经常或周期性地接受药物治疗',
    '您的孩子是否还有其他的医疗病史': '您的孩子是否还有其他的医疗病史',
    '您的孩子是否有饮食禁忌': '您的孩子是否有饮食禁忌',
    '其它细节': '其它细节',
    '若您的孩子不适合参加户外运动、体育课程或其他运动，请在以下注明，并提交一份有关的体格证明，以供园方参考:': '若您的孩子不适合参加户外运动、体育课程或其他运动，请在以下注明，并提交一份有关的体格证明，以供园方参考:',
    '若您的孩子因宗教信仰或其他非药物原因，在饮食上有别的要求，请注明:': '若您的孩子因宗教信仰或其他非药物原因，在饮食上有别的要求，请注明:',
    '肖像使用确认事宜': '肖像使用确认事宜',
    '官网、微博（内部）使用': '官网、微博（内部）使用',
    '同意': '同意',
    '不同意': '不同意',
    '宣传刊物（校内和校外）使用': '宣传刊物（校内和校外）使用',
    '企业宣传片使用': '企业宣传片使用',
    '户外大型广告使用': '户外大型广告使用',
    '你愿意到幼儿园来参加有关您所庆祝节日的活动吗？包括讲故事，唱歌或者其他类型的一些活动。': '你愿意到幼儿园来参加有关您所庆祝节日的活动吗？包括讲故事，唱歌或者其他类型的一些活动。',
    '你愿意义务帮助组织或者在幼儿园出游时帮助照看我们的孩子吗？': '你愿意义务帮助组织或者在幼儿园出游时帮助照看我们的孩子吗？',
    '父亲详细信息': '父亲详细信息',
    '身份证号': '身份证号',
    '目前单位与职位': '目前单位与职位',
    '母语': '母语',
    '单位地址': '单位地址',
    '单位电话': '单位电话',
    '单位传真': '单位传真',
    '电子邮件': '电子邮件',
    '微信号': '微信号',
    '备注': '备注',
    'Comments': '备注',
    '母亲详细信息': '母亲详细信息',
    '兄弟姐妹信息': '兄弟姐妹信息',
    '目前所在幼儿园': '目前所在幼儿园',
    '女': '女',
    '男': '男',
    '家庭语言信息': '家庭语言信息',
    '曾就读园所': '曾就读园所',
    '地址': '地址',
    '该园的教育语言': '该园的教育语言',
    '孩子的母语': '孩子的母语',
    '其他可交流语言': '其他可交流语言',
    '母亲的母语': '母亲的母语',
    '父亲的母语': '父亲的母语',
    '家庭所用语言': '家庭所用语言',
    '您如何评价您孩子的英语水平：': '您如何评价您孩子的英语水平：',
    '您的孩子在园外是否参加语言学习？如有，请注明：': '您的孩子在园外是否参加语言学习？如有，请注明：',
    '紧急联系人': '紧急联系人',
    '第一紧急联系人（除家长）': '第一紧急联系人（除家长）',
    '与孩子的关系': '与孩子的关系',
    '移动电话': '移动电话',
    '工作电话': '工作电话',
    '第二紧急联系人（除家长）': '第二紧急联系人（除家长）',
    '首选医院名称': '首选医院名称',
    '若园方无法联络到上述联系人，请在下列注明家长希望把孩子送至紧急治疗的医院或诊所名称（首选医院名称）': '若园方无法联络到上述联系人，请在下列注明家长希望把孩子送至紧急治疗的医院或诊所名称（首选医院名称）',
    '请注意：若家长不指定任何医院，或指定的医院并没有所需之治疗服务，园方将根据紧急情况将孩子送往就近最合适的医院。': '请注意：若家长不指定任何医院，或指定的医院并没有所需之治疗服务，园方将根据紧急情况将孩子送往就近最合适的医院。',
    '孩子是否持有医疗和意外保险？如果有，请填入保险信息': '孩子是否持有医疗和意外保险？如果有，请填入保险信息',
    '有': '有',
    '没有': '没有',
    '保险公司': '保险公司',
    '保险单号码': '保险单号码',
    '保险项目': '保险项目',
    '校车申请及其他信息': '校车申请及其他信息',
    '搭乘校车': '搭乘校车',
    '不需要': '不需要',
    '需要': '需要',
    '搭乘种类': '搭乘种类',
    '双程': '双程',
    '搭车去幼儿园': '搭车去幼儿园',
    '搭车回家': '搭车回家',
    '接送地址': '接送地址',
    '您的孩子对食物有没有特殊的要求？': '您的孩子对食物有没有特殊的要求？',
    '您的家庭庆祝什么节日？（国家或民族的特别节日）': '您的家庭庆祝什么节日？（国家或民族的特别节日）',
    '您的孩子有宠物吗？': '您的孩子有宠物吗？',
    '您的孩子在睡觉时有喜欢的玩具吗？': '您的孩子在睡觉时有喜欢的玩具吗？',
    '请输入填表人签字': '请输入填表人签字',
    '全部': '全部',
    '在校': '在校',
    '休学': '休学',
    '毕业': '毕业',
    '退学(已退费)': '退学(已退费)',
    '退学(未退费)': '退学(未退费)',
    '学生档案导入模板下载': '学生档案导入模板下载'
  },
  push: {
    '中文消息': '中文消息',
    '英文消息': '英文消息',
    '品牌': '品牌',
    '发送': '发送'
  },
  national: {
    '中国': '中国',
    '美国': '美国',
    '加拿大': '加拿大',
    '澳大利亚': '澳大利亚',
    '英国': '英国',
    '法国': '法国',
    '德国': '德国',
    '意大利': '意大利',
    '俄罗斯': '俄罗斯',
    '巴西': '巴西',
    '印度': '印度',
    '希腊': '希腊',
    '爱尔兰': '爱尔兰',
    '西班牙': '西班牙',
    '日本': '日本',
    '瑞士': '瑞士'
  },
  language: {
    '汉语': '汉语',
    '英语': '英语',
    '意大利语': '意大利语',
    '俄语': '俄语',
    '日语': '日语',
    '爱尔兰语': '爱尔兰语',
    '希腊语': '希腊语',
    '德语': '德语',
    '西班牙语': '西班牙语',
    '瑞士语': '瑞士语',
    '葡萄牙语': '葡萄牙语'
  },
  studentAssessments: {
    '语言': '语言',
    '请选择年龄': '请选择年龄',
    '请选择评量时间': '请选择评量时间',
    '切换语言': '切换语言',
    '2岁': '2岁',
    '2岁半': '2.5岁',
    '3岁': '3岁',
    '3岁半': '3.5岁',
    '4岁': '4岁',
    '4岁半': '4.5岁',
    '5岁': '5岁',
    '5岁半': '5.5岁',
    '6岁': '6岁',
    '岁': '岁',
    '学年初(Beginning)': '学年初(Beginning)',
    '学年初': '学年初',
    '学年中(Middle)': '学年中(Middle)',
    '学年中': '学年中',
    '学年末(End)': '学年末(End)',
    '学年末': '学年末',
    '托班(Pre)': '托班(Pre)',
    '小班(Junior)': '小班(Junior)',
    '中班(Middle)': '中班(Middle)',
    '大班(Senior)': '大班(Senior)',
    '查看评量依据': '查看评量依据',
    '语言(language):': '语言(language):',
    '选择题库：': '选择题库:',
    '题库': '题库',
    '评量时间': '评量时间',
    '评量方案': '评量方案',
    '评量结果图': '评量结果图',
    '评量对比图': '评量对比图',
    '选择题库:': '选择题库'
  },
  tuitionBillsTemplates: {
    '从学费档案导入': '从学费档案导入',
    '导入到缴费项目': '导入到缴费项目'
  },
  optionalFunction: {
    '上传原图': '上传原图',
    '显示托婴': '显示托婴',
    '显示监控': '显示监控',
    '隐藏教案': '隐藏教案',
    '隐藏家庭作业': '隐藏校外活动',
    '隐藏评量': '隐藏评量',
    '显示教研培训': '显示教研培训',
    '隐藏服药单': '隐藏服药单',
    '隐藏学员手册': '隐藏学员手册',
    '显示表格管理': '显示表格管理',
    '隐藏预设教案': '隐藏预设教案',
    '隐藏校车': '隐藏校车',
    '隐藏招生': '隐藏招生',
    '教学记录个数限制': '教学记录个数限制',
    '班级圈发布次数限制': '班级圈发布次数限制',
    '视频时长限制（秒）': '视频时长限制（秒）',
    '显示工资单': '显示工资单',
    '显示预缴学费管理': '显示预缴学费管理',
    '隐藏健康日报': '隐藏健康日报',
    '隐藏学费单': '隐藏学费单',
    '显示轶事记录-观察分析': '显示轶事记录-观察分析',
    '隐藏教学记录': '隐藏教学记录',
    '隐藏学生作品': '隐藏学生作品',
    '隐藏班级圈照片': '隐藏班级圈照片',
    '显示轶事记录下载教委版': '显示轶事记录下载教委版',
    '隐藏签到': '隐藏签到',
    '隐藏请销假': '隐藏请销假',
    '隐藏叮嘱': '隐藏叮嘱',
    '隐藏关怀问候': '隐藏关怀问候',
    '显示我的助手': '显示我的助手',
    '我的助手会话次数限制': '助手会话次数限制'
  },
  ysCamera: {
    '设备名称': '设备名称',
    '请输入设备名称': '请输入设备名称',
    '直播地址': '直播地址',
    '提示：数字越大越靠前': '提示：数字越大越靠前',
    '请输入直播地址': '请输入直播地址'
  },
  punch: {
    'WiFi名称': 'WiFi名称',
    'Mac地址1': 'MAC地址1',
    'Mac地址2': 'MAC地址2',
    'Mac地址3': 'MAC地址3',
    'Mac地址4': 'MAC地址4',
    'Mac地址5': 'MAC地址5',
    '工作开始时间': '上班时间',
    '工作结束时间': '下班时间',
    '启用': '启用',
    '停用': '停用',
    '已启用': '已启用',
    '已停用': '已停用',
    '启用提示': '启用后手机端将会显示打卡功能，请提醒老师们进行打卡操作',
    '停用提示': '停用后手机端将不会再显示打卡功能，确定要停用吗？',
    'WiFi名称提示': '可在手机的WiFi设置中查看',
    'Mac提示': '可用手机下载腾讯WiFi管家查看。格式为：xx:xx:xx:xx:xx:xx',
    'WiFi名称PlaceHolder': '请输入WiFi名称',
    'Mac地址PlaceHolder': '请输入MAC地址',
    '工作开始时间PlaceHolder': '请选择工作开始时间',
    '工作结束时间PlaceHolder': '请选择工作结束时间',
    '请选择月份': '请选择月份',
    '外勤': '外勤',
    '迟到': '迟到',
    '早退': '早退',
    '打卡记录下载': '打卡记录下载'
  },
  personalInfoProtection: {
    '个人信息保护': '个人信息保护',
    '数据处理': '数据处理',
    '已毕业学生档案脱敏': '已毕业学生档案脱敏',
    '数量': '数量：',
    '已毕业学生家长删除': '已毕业学生家长删除',
    '已毕业班级教学记录删除': '已毕业班级教学记录删除',
    '已毕业班级班级圈删除': '已毕业班级班级圈删除',
    '执行确认': '确认要执行此操作吗？',
    '执行成功': '执行成功',
    '已毕业学生数据删除': '已毕业学生数据删除',
    '任务创建成功，系统将在夜间自动处理': '任务创建成功，系统将在夜间自动处理',
    '请选择需要删除的数据': '请选择需要删除的数据',
    '删除选择日期之前的校园通知': '删除选择日期以前的校园通知',
    '校园通知删除': '校园通知删除'
  },
  resetPassword: {
    '重置密码': '重置密码',
    '保存成功': '密码重置成功',
    '忘记密码': '忘记密码？',
    '请重置密码': '请重置密码'
  },
  admission: {
    '招生': '招生',
    '收费标准': '收费标准',
    '起始日期': '起始日期',
    '请选择起始日期': '请选择起始日期',
    '学费（人）-国际班': '学费（人）-国际班',
    '月缴费价格': '月缴费价格',
    '学期缴费价格（5个月）': '学期缴费价格（5个月）',
    '学年缴费价格（10个月）': '学年缴费价格（10个月）',
    '学费（人）-双语班': '学费（人）-双语班',
    '学费（人）-混龄班': '学费（人）-混龄班',
    '一次性费用': '一次性费用',
    '餐费': '餐费',
    '餐费规格': '餐费规格',
    '校车费（人/月）此处公里数为往返总公里数': '校车费（人/月）',
    '10公里内': '10公里内',
    '10-20公里': '10-20公里',
    '20公里以上': '20公里以上',
    '定金费用': '定金费用',
    '备注': '备注',
    '收费项目': '收费项目',
    '折扣政策': '折扣政策',
    '保教费-双语班': '保教费-双语班',
    '保教费-国际班/混班': '保教费-国际班/混班',
    '伙食费': '伙食费',
    '校车费': '校车费',
    '入学一次性费用': '入学一次性费用',
    '代办费': '代办费',
    '其他': '其他',
    '对外': '对外',
    '员工': '员工',
    '特殊': '特殊',
    '汇总下载': '汇总下载',
    '班级状况': '班级状况',
    '满园人数': '满园人数',
    '应出勤人数': '应出勤人数',
    '招生目标人数': '招生目标人数',
    '实际出勤人数': '实际出勤人数',
    '小班双语班': '小班双语班',
    '小班国际班': '小班国际班',
    '中班双语班': '中班双语班',
    '中班国际班': '中班国际班',
    '大班双语班': '大班双语班',
    '大班国际班': '大班国际班',
    '托班双语班': '托班双语班',
    '托班国际班': '托班国际班',
    '班级数': '班级数',
    '满班学生数': '满班学生数',
    '当前学生数': '当前学生数',
    '新开班型': '新开班型',
    '新开班级数及最新人数': '新开班级数及最新人数',
    '空余教室': '空余教室',
    '教室数量': '教室数量',
    '招生年度计划': '招生年度计划',
    '输入年搜索': '请输入年度搜索',
    '年度': '年度',
    '请输入年度': '请输入年度',
    '现有班型': '现有班型',
    '在册人数': '在册人数',
    '1月在园人数': '1月在园人数',
    '12月计划在园人数': '12月计划在园人数',
    '第一季度': '第一季度',
    '第二季度': '第二季度',
    '第三季度': '第三季度',
    '第四季度': '第四季度',
    '计划招生人数': '计划招生人数',
    '实际招生人数': '实际招生人数',
    '计划入园人数': '计划入园人数',
    '实际入园人数': '实际入园人数',
    '7月份毕业班数': '7月份毕业班数',
    '7月份毕业人数': '7月份毕业人数',
    '9月份预计开班数': '9月份预计开班数',
    '请在年度搜索输入后点击下载': '请在年度搜索输入后点击下载',
    '客户线索与商机': '客户线索与商机',
    '月份': '月份',
    '线索数': '线索数',
    '商机数': '商机数',
    '去年季度同比汇总下载': '去年季度同比汇总下载',
    '请选择月份': '请选择月份',
    '请输入线索': '请输入线索数',
    '请输入商机': '请输入商机数',
    '客户来源分析': '客户来源分析',
    '季度分析汇总下载': '季度分析汇总下载',
    '仅推荐补历史数据时填写，不填写则系统会自动算出人数': '仅推荐补历史数据时填写，不填写则系统会自动算出人数',
    '招生计划完成率汇总下载': '招生年度计划完成率汇总下载',
    '实际招生人数分析': '实际招生人数分析',
    '年度实际招生人数下载': '年度实际招生人数下载',
    '近3年月度同比分析汇总下载': '近3年月度同比分析汇总下载',
    '近3年季度同比分析汇总下载': '近3年季度同比分析汇总下载',
    '客户信息': '客户信息',
    '潜在生来访分析及跟进记录下载': '潜在生来访分析及跟进记录下载',
    '请选择参观日期范围': '请选择参观日期范围',
    '联系人': '联系人',
    '负责人': '负责人',
    '全部': '全部',
    '新客户': '新客户',
    '建立联系': '建立联系',
    '参观园所': '参观园所',
    '预定学位': '预定学位',
    '缴纳学费': '缴纳学费',
    '姓名、联系电话检索': '姓名、联系电话检索',
    '商机状态': '商机状态',
    '商机未关闭': '进行中',
    '商机成功': '商机成功',
    '商机失败': '商机失败',
    '自己负责': '自己负责',
    '其他老师负责': '其他老师负责',
    '请输入宝宝姓名': '请输入宝宝姓名',
    '宝宝姓名': '宝宝姓名',
    '小名': '小名',
    '民族': '民族',
    '联系人姓名': '联系人姓名',
    '和宝宝关系': '和宝宝关系',
    '联系人电话': '联系人电话',
    '预约班级': '预约班级',
    '是否坐校车': '是否坐校车',
    '客户来源': '客户来源',
    '状态': '状态',
    '商机关闭原因': '商机关闭原因',
    '请选择客户来源': '请选择客户来源',
    '预约记录': '预约记录',
    '沟通记录': '沟通记录',
    '优惠券': '优惠券',
    '沟通日期': '沟通日期',
    '已处理': '已处理',
    '未处理': '未处理',
    '是否电话交流': '是否电话交流',
    '预约参观': '预约参观',
    '预约试听课': '预约试听课',
    '退园人数分析': '退园人数分析',
    '年度退园人数下载': '年度退园人数下载',
    '业财对账': '业财对账',
    '姓名检索': '姓名检索',
    '老生退款信息追加': '老生退款信息追加',
    '待业务处理': '待业务处理',
    '待财务处理': '待财务处理',
    '财务已处理': '已处理完毕',
    '注意：此功能只用于未在客户信息内录入过的学生': '注意：以前进行过业财对账的学生，编辑之前的对账记录，并添加退款信息即可。此功能只用于未在客户信息内录入、未进行过业财对账的学生',
    '定金金额': '定金金额',
    '定金转全款金额': '定金转全款金额',
    '全款金额': '全款金额',
    '招生确认': '招生确认',
    '财务确认': '财务确认',
    '折扣率': '折扣率',
    '折扣金额': '折扣金额',
    '退定金金额': '退定金金额',
    '退全款金额': '退全款金额',
    '已入园退全款金额': '已入园退全款金额',
    '请输入金额': '请输入金额',
    '请打勾': '请打勾',
    '请输入姓名': '请输入姓名',
    '入园日期': '入园日期',
    '周报': '周报',
    '提交人': '提交人',
    '提交日期': '提交日期',
    '报告日期': '报告日期',
    '以下为系统自动计算': '以下为系统自动计算',
    '在园人数': '在园人数',
    '新入园人数': '新入园人数',
    '交订金转全款人数': '交订金转全款人数',
    '交订金人数': '交订金人数',
    '交全款人数': '交全款人数',
    '退订金人数': '退订金人数',
    '退全款人数': '退全款人数',
    '退园人数': '退园人数',
    '搜集潜在生名单人数': '搜集潜在生名单人数',
    '来园参访人数': '来园参访人数',
    '电话咨询人数': '电话咨询人数',
    '夏季毕业人数': '夏季毕业人数',
    '高意向人数': '高意向人数',
    '夏季预计毕业人数': '夏季预计毕业人数',
    '招生宣讲次数': '校内宣讲次数',
    '校内试听课次数': '校内试听课次数',
    '举办校外推广次数': '举办校外推广次数',
    '班型详细说明': '班型详细说明',
    '学费信息': '学费信息',
    '退定金、退全款、退园分析': '退定金、退全款、退园分析',
    '成功经验总结': '成功经验总结',
    '下周重点工作安排': '下周重点工作安排',
    '班级数为在校班级总数': '在校班级总数',
    '在校加休学人数': '在校加休学人数，含预备班',
    '在校人数': '在校人数',
    '以第一次签到日期计算': '以第一次签到日期计算',
    '通过业财对账数据统计': '通过业财对账业务确认日期统计',
    '新增客户数': '新增客户数',
    '时间段内状态变更为参观园所的客户数量': '时间段内状态变更为参观园所的客户数量',
    '时间段内状态变更为建立联系的客户数量': '时间段内状态变更为建立联系的客户数量',
    '6月1日至8月31日之间内状态变更为毕业的学生人数': '6月1日至8月31日之间状态变更为毕业的学生人数',
    '请填写此项': '请填写此项',
    '招生周数据统计下载': '招生周数据统计下载',
    '请选择统计日期范围': '请选择统计日期范围',
    '保存后请进行业财对账': '保存后请进行业财对账',
    '意向度': '意向度',
    '1-10分，越大意向越高': '1-10分，越大意向越高',
    '园所': '园所',
    '预约待处理': '预约待处理',
    '没有负责人': '没有负责人',
    '未知': '未知'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js